import React from "react";
import MangeDashboard from "./MangeDashboard";
import {useHistory} from "react-router-dom";



export default function (){

    return(
        <MangeDashboard>
        <div className="verification section-padding">
            <div className="container h-100">
                <div className="row justify-content-center h-100 align-items-center">
                    <div className="col-xl-5 col-md-6">
                        <div className="auth-form card">
                            <div className="card-body">
                                <form action="verify-step-4.html" className="identity-upload">
                                    <div className="identity-content">
                                        <span className="icon"><i className="fa fa-shield"/></span>
                                        <h6> ما در حال تأیید شناسه شما هستیم </h6>
                                        <p className={'text-large'}>هویت شما در حال تأیید است. پس از پایان تأیید ، به شما اطلاع رسانی میشود.
                                        </p>
                                    </div>

                                    <div className="upload-loading text-center mb-3">
                                        <i className="fa fa-spinner fa-spin fa-3x fa-fw"/>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </MangeDashboard>


    )
}